// Necessary if using App Router to ensure this file runs on the client
'use client'
import { useAuth0 } from '@auth0/auth0-react'
import { datadogRum } from '@datadog/browser-rum'
import { useEffect } from 'react'

import { useMyself } from '@/api/users'
import { APP_PATHS } from '@/global/consts'
import ENV_VARS from '@/global/environmentVariables'

// Only initialize if we're in production
if (ENV_VARS.VERCEL_ENV === 'production') {
  datadogRum.init({
    applicationId: ENV_VARS.DATADOG_APPLICATION_ID!,
    clientToken: ENV_VARS.DATADOG_CLIENT_TOKEN!,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'cleanlab-codex-frontend',
    env: 'production',
    // Specify a version number to identify the deployed version of your application in Datadog
    version: '0.1.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    beforeSend(event) {
      // discard pages from admin routes
      for (const [_key, value] of Object.entries(APP_PATHS).filter(([key]) =>
        key.startsWith('ADMIN_')
      )) {
        if (event.view?.url?.includes(value)) {
          return false
        }
      }

      return true
    },
  })
}

export default function DatadogInit() {
  const { isAuthenticated } = useAuth0()
  const { data: myself } = useMyself()
  const { email, name, id: userId } = myself ?? {}

  useEffect(() => {
    if (ENV_VARS.VERCEL_ENV === 'production' && isAuthenticated && myself) {
      datadogRum.setUser({
        id: userId?.toString(),
        name: name ?? undefined,
        email: email ?? undefined,
      })
    }
  }, [isAuthenticated, myself, userId, name, email])

  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null
}
